<p-dialog [(visible)]="isOpen" 
          [modal]="true" 
          [header]="'modal_medical_percentages_title' | translate" 
          [style]="{ width: '600px' }"
          [breakpoints]="{ '960px': '75vw', '641px': '95vw' }"
          [draggable]="false"
          [resizable]="false"
          (onHide)="onClose()">
    
    <ng-template pTemplate="header">
        <div>
            <h3 class="text-xl font-black text-slate-800 uppercase tracking-widest">{{ 'modal_medical_percentages_title' | translate }}</h3>
            <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">{{ 'modal_medical_percentages_subtitle' | translate }}</p>
        </div>
    </ng-template>

    <div class="pt-2">
        <div class="rounded-2xl border border-slate-100 overflow-hidden shadow-sm">
            <!-- Table Header -->
            <div class="bg-slate-50 px-5 py-4 border-b border-slate-100 flex justify-between items-center">
                <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ 'modal_medical_percentages_professional' | translate }}</span>
                <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ 'modal_medical_percentages_percentage' | translate }}</span>
            </div>

            <!-- List -->
            <div *ngIf="loading" class="p-8 text-center text-gray-500">
                <i class="pi pi-spin pi-spinner mr-2"></i>
                {{ 'common_loading' | translate }}...
            </div>

            <div *ngIf="!loading && doctorsList.length === 0" class="p-8 text-center text-gray-500">
                {{ 'common_no_data' | translate }}
            </div>

            <div *ngIf="!loading && doctorsList.length > 0" class="divide-y divide-slate-100 bg-white">
                <div *ngFor="let item of doctorsList"
                    class="px-5 py-4 flex items-center justify-between hover:bg-slate-50 transition-colors">
                    <!-- Doctor Info -->
                    <div class="flex items-center gap-4 flex-1 overflow-hidden">
                        <img [src]="item.doctor.photo || 'assets/images/user-profile.png'"
                            onerror="this.src='assets/images/user-profile.png'"
                            class="w-10 h-10 rounded-xl object-cover bg-slate-100 border border-slate-100 shadow-sm" alt="Avatar">
                        <span class="text-sm font-bold text-slate-700 truncate block">{{ item.doctor.name }}</span>
                    </div>

                    <!-- Percentage -->
                    <div class="flex items-center justify-end w-44 gap-2">
                        <ng-container *ngIf="!item.editing">
                            <span class="text-sm font-black text-primary uppercase tracking-widest">{{ item.percent }} %</span>
                            <button (click)="startEdit(item)" class="text-slate-400 hover:text-primary ml-4 p-2 transition-colors rounded-lg hover:bg-white">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                            </button>
                        </ng-container>

                        <ng-container *ngIf="item.editing">
                            <p-inputNumber [(ngModel)]="item.tempPercent" 
                                           suffix=" %"
                                           class="percent-input"
                                           [min]="0" [max]="100"></p-inputNumber>

                            <button pButton 
                                    icon="pi pi-check" 
                                    [loading]="item.loading"
                                    (click)="saveEdit(item)"
                                    class="p-button-rounded p-button-sm p-button-primary !p-2 !w-8 !h-8 ml-2"></button>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>